
import Star from '../assets/star.png';
//import Noodles from '../assets/food/noodles-placeholder.png';
import BuffaloChicken from "../assets/food/recents/noodles/buffalo-chicken-noodles.png";
import Cheesesteak from "../assets/food/recents/noodles/cheesesteak-noodles2.png";
import ChickenPotPie from "../assets/food/recents/noodles/chicken-pot-pie-noodles.png";
import HoneyChipotle from "../assets/food/recents/noodles/honey-chipotle-chicken-noodles.png";
import ItalianRoast from "../assets/food/recents/noodles/roast-pork.png";
//import ChickenParm from "../assets/food/recents/noodles/chicken-parm-noodles.png";
//import ChickenBaconRanch from "../assets/food/recents/noodles/cbr.png"
import BanhMi from "../assets/food/recents/noodles/banh-mi-noodles.png"




const bowls = [
    { "id": 1, "meal":"Buffalo Chicken", "image": BuffaloChicken, "vegan" : "", "star": "", "info": "Crispy chicken bites and Humpty's Mild Wing sauce. garnished with blue cheese crumbles and a drizzle of ranch."},
    { "id": 2, "meal":"Chicken Pot Pie", "image": ChickenPotPie, "vegan" : "", "star": "","info": "Chicken breast, mixed veggies, homemade gravy. topped with pie crust crumbles and shredded carrots."},
    { "id": 3, "meal":"Cheesesteak", "image": Cheesesteak, "vegan" : "", "star": "","info": "Chip steak, peppers, onions, cheese sauce. garnished with scallions."},
    { "id": 4, "meal":"Italian Roast Pork", "image": ItalianRoast, "vegan" : "", "star": "","info": "Pork loin, broccoli rabe, sharp provolone with our own housemade herb and garlic sauce."},
    { "id": 5, "meal":"Honey Chipotle Chicken", "image": HoneyChipotle, "vegan" : "", "star": "", "info": "Sauteed onions and crispy chicken tossed in Humpty's Honey BBQ sauce with a ranch drizzle and scallion garnish."},
    { "id": 6, "meal":"Banh Mi", "image": BanhMi, "vegan" : "", "star": Star, "info": "Nuoc cham marinated flank steak, pickled carrots & daikon, sliced jalapeno, and drizzled with a spicy vietnamese aioli."},
   
    

];

export default bowls;